import {InjectionToken} from '@angular/core';

export interface IEnvironment {
  production: boolean,
  hmr: boolean,
  apiUrl: string,
  appUrl: string,
  locale: ILocaleConfig;
  allowTokenLogins: boolean;
  enableBulkUpload:boolean;
  enableAIBulkUpload: boolean;
  sentry?: {
      enabled: boolean;
      dsn: string;
      environment?: string;
  };
  socialLoginsURL:{
      baseURL:string;
      linkedin: string;
      microsoft: string;
      google: string;
  },
  samlLoginUrl:string;
}

export interface ILocaleConfig {
  defaultLanguage: string;
  availableLanguages: string[];
}

export const IEnvironmentToken = new InjectionToken<IEnvironment>('IEnvironmentToken');